module.exports = __webpack_public_path__ + "img/louisa-may-alcott.1cf62c38.png";